import { IApplicationState } from '../../types/redux';

export const getShouldAutoOpen = (state: IApplicationState): boolean => {
  return state.newReview.meta.shouldAutoOpen;
};
